import { FileItem } from '../../api/ApiTypes'

export const MOCK_DOCUMENTS: { results: FileItem[]; hits: number } = {
  results: [
    {
      _id: '1',
      filename: 'Contract_Agreement.pdf',
      public_url: 'https://www.google.com',
      _created_at: '2021-01-01',
      _updated_at: '2021-01-01',
      _title: 'Contract Agreement',
      _org: '123',
      _schema: 'file',
      type: 'document',
      category: 'legal',
      readable_size: '2.4 MB',
      is_new: true
    },
    {
      _id: '2',
      filename: 'Invoice_2021.pdf',
      public_url: 'https://www.google.com',
      _created_at: '2021-02-01',
      _updated_at: '2021-02-01',
      _title: 'Invoice 2021',
      _org: '123',
      _schema: 'file',
      type: 'document',
      category: 'billing',
      readable_size: '1.8 MB',
      is_new: false
    },
    {
      _id: '3',
      filename: 'Technical_Specifications.pdf',
      public_url: 'https://www.google.com',
      _created_at: '2021-03-01',
      _updated_at: '2021-03-01',
      _title: 'Technical Specifications',
      _org: '123',
      _schema: 'file',
      type: 'document',
      category: 'documentation',
      readable_size: '3.1 MB',
      is_new: true
    },
    {
      _id: '4',
      filename: 'Service_Report.pdf',
      public_url: 'https://www.google.com',
      _created_at: '2021-04-01',
      _updated_at: '2021-04-01',
      _title: 'Service Report',
      _org: '123',
      _schema: 'file',
      type: 'spreadsheet',
      category: 'documentation',
      readable_size: '892 KB',
      is_new: false
    },
    {
      _id: '5',
      filename: 'Warranty_Information.pdf',
      public_url: 'https://www.google.com',
      _created_at: '2021-05-01',
      _updated_at: '2021-05-01',
      _title: 'Warranty Information',
      _org: '123',
      _schema: 'file',
      type: 'document',
      category: 'legal',
      readable_size: '1.2 MB',
      is_new: true
    }
  ],
  hits: 5
}
